import React, { useState, useEffect } from 'react';

function createAsyncWrapper(className, lazyComponents) {
  const path = Object.keys(lazyComponents).find((componentPath) => componentPath.match(new RegExp(`/${className}(\\.(js|jsx|ts|tsx)|/index\\.js)$`)));

  if (!path) {
    // eslint-disable-next-line no-console
    console.error(`Could not find component: ${className}`, lazyComponents);
    return () => (
      <div style={{ color: 'red' }}>
        <b>Component not found: </b>
        {className}
      </div>
    );
  }

  return function AsyncComponentWrapper(props) {
    const [Component, setComponent] = useState(null);

    useEffect(() => {
      let isMounted = true;
      lazyComponents[path]().then((mod) => {
        if (isMounted) setComponent(() => mod.default);
      });
      return () => {
        isMounted = false;
      };
    }, []);

    return Component ? <Component {...props} /> : null;
  };
}

export default createAsyncWrapper;
